import React from "react";
import { useEditor } from "@craftjs/core";
import styled from "@emotion/styled";

const StylePanelStyled = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  height: 100%;
  font-size: 11px;

  h5 {
    font-size: small;
    color: lightgray;
    text-align: left;
  }

  input,
  textarea,
  select {
    outline: none;
    position: relative;
    font-family: sans-serif;
  }
`;
export const StylePanel = () => {
  const { active, related } = useEditor((state, query) => {
    // TODO: handle multiple selected elements
    const currentlySelectedNodeId = query.getEvent("selected").first();
    return {
      active: currentlySelectedNodeId,
      related:
        currentlySelectedNodeId && state.nodes[currentlySelectedNodeId].related,
    };
  });

  return (
    <StylePanelStyled>
      {active && related.styles && React.createElement(related.styles)}
      {!active && (
        <>
          <p className="pb-1">Click on a component to start editing.</p>
          <p>
            You could also double click on the layers below to edit their names,
            like in Photoshop
          </p>
        </>
      )}
    </StylePanelStyled>
  );
};
